"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Firmware = void 0;
class Firmware {
    constructor(name, data, storage) {
        this.name = name;
        this.data = data;
        this.storage = storage;
    }
    get version() {
        return parseInt(this.data["fw_version"], 10);
    }
    get size() {
        return parseInt(this.data["fw_size"], 10);
    }
    get fileSystemVersion() {
        return parseInt(this.data["fs_version"], 10);
    }
    get fileSystemSize() {
        return parseInt(this.data["fs_version"], 10);
    }
    isNewerThan(firmware) {
        return this.name === firmware.name && this.version > firmware.version;
    }
}
exports.Firmware = Firmware;
//# sourceMappingURL=Firmware.js.map